// WhatsApp Nurederm Button - Auto Message (Language Adaptive)
(function() {
  // Product title selectors
  const TITLE_SELECTORS = [
    '.product-info h1',
    '.product-info .h1',
    '[data-block-type="title"] h1',
    '[data-block-type="title"] .h1',
    '.product-title',
    '.product__title',
    'h1.product-title'
  ].join(', ');

  /**
   * Returns current Shopify locale code (e.g. 'tr', 'en', 'ar')
   */
  function getLocale() {
    return (window.Shopify && window.Shopify.locale) ||
           document.documentElement.lang ||
           'tr';
  }

  /**
   * Builds a language-adaptive WhatsApp message
   */
  function buildMessage(productName, productUrl, locale) {
    switch (locale) {
      case 'tr':
        return `Merhaba, "${productName}" ürününün fiyatı hakkında bilgi almak istiyorum.\n\nÜrün Linki: ${productUrl}`;
      case 'ar':
        return `مرحبًا، أود الحصول على معلومات حول سعر "${productName}".\n\nرابط المنتج: ${productUrl}`;
      case 'de':
        return `Hallo, ich möchte Preisinformationen über "${productName}" erhalten.\n\nProduktlink: ${productUrl}`;
      case 'fr':
        return `Bonjour, je souhaite obtenir des informations sur le prix de "${productName}".\n\nLien produit : ${productUrl}`;
      case 'ru':
        return `Здравствуйте, я хотел бы получить информацию о цене "${productName}".\n\nСсылка на товар: ${productUrl}`;
      default:
        return `Hello, I would like to get price information about "${productName}".\n\nProduct Link: ${productUrl}`;
    }
  }

  /**
   * Sets up WhatsApp button with auto-populated, language-adaptive message
   */
  function setupWhatsAppButton() {
    const whatsappButton = document.querySelector('.whatsapp-button');
    if (!whatsappButton) return;

    const productTitleEl = document.querySelector(TITLE_SELECTORS);
    if (!productTitleEl) {
      console.log('Product title not found for WhatsApp message');
      return;
    }

    const productName = productTitleEl.textContent.trim();
    const productUrl  = window.location.href;
    const locale      = getLocale();
    const message     = buildMessage(productName, productUrl, locale);

    const baseUrl = whatsappButton.getAttribute('href').split('?')[0];
    whatsappButton.setAttribute('href', `${baseUrl}?text=${encodeURIComponent(message)}`);

    console.log('WhatsApp message set for:', productName, '| locale:', locale);
  }

  document.addEventListener('DOMContentLoaded', setupWhatsAppButton);

  document.addEventListener('shopify:section:load', function() {
    setTimeout(setupWhatsAppButton, 100);
  });
})();
